export const INTRO_ILLUSTRATION = 'INTRO_ILLUSTRATION'
export const CUSTOMIZE_LOGO_DESC = 'CUSTOMIZE_LOGO_DESC'
export const CUSTOMIZE_LOGO = 'CUSTOMIZE_LOGO'
export const SET_TAGLINE = 'SET_TAGLINE'
export const HERO_IMAGE = 'HERO_IMAGE'
export const BULLET_POINTS = 'BULLET_POINTS'
export const BULLET_POINTS_BACKGROUND = 'BULLET_POINTS_BACKGROUND'
export const BULLET_POINTS_BACKGROUND_CROP = 'BULLET_POINTS_BACKGROUND_CROP'
export const FINAL_SCENE = 'FINAL_SCENE'
export const FINAL_SCENE_TEXT = 'FINAL_SCENE_TEXT'
export const FINAL_SCENE_BACKGROUND = 'FINAL_SCENE_BACKGROUND'
export const FINAL_SCENE_BACKGROUND_CROP = 'FINAL_SCENE_BACKGROUND_CROP'
export const FINAL_PREVIEW = 'FINAL_PREVIEW'
export const PRODUCTS_SCENES_DASHBOARD = 'PRODUCTS_SCENES_DASHBOARD'
export const PRODUCTS_SCENES_DASHBOARD_NEW = 'PRODUCTS_SCENES_DASHBOARD_NEW'
export const PRODUCTS_SCENES_DASHBOARD_EMPTY = 'PRODUCTS_SCENES_DASHBOARD_EMPTY'
export const PRODUCT_SCENE_BACKGROUND = 'PRODUCT_SCENE_BACKGROUND'
export const PRODUCT_SCENE_BACKGROUND_CROP = 'PRODUCT_SCENE_BACKGROUND_CROP'



// WEBPACK FOOTER //
// ./src/constants/shopifyAppSceneId.js